<div *ngIf="content_initialized" class="flex-display" aria-label="NoticetoconstituentsPage">
  <div class="float-L width-86" tabindex="0">
    <div class="pr-96px pr-1-25">
      <div class="pcform pr-1-25 line-height-inherit print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont content-display pb-1">{{ntc_header}}</h1>
        <p class="answer font-16 content-blue width-100" (click)="openLinkById($event)" [innerHTML]="ntc_body"></p>
        <span class="para">
          <span class="mr_0_5rem pdf-link" (click)="openLinkById($event)" [innerHTML]="ntc_link" (keyup.enter)="openLinkById($event)" tabindex="0"> </span>
          <img src="../../../assets/icons/PDF_icon.svg" alt="PDF" class="pdf-image h-20px">
        </span>

      </div>
    </div>
  </div>
</div>

